;(function () {
  'use strict'

  angular
    .module('contrast.reports.filter')
    .controller('ReportViewCtrl', ReportViewCtrl)

  function ReportViewCtrl(
    $scope,
    $route,
    $location,
    $q,
    $translate,
    logger,
    dialogs,
    HistoryService,
    ErrorService,
    reportFilterService,
    PromiseService,
    complianceReportService,
    ApplicationFactory,
    ServerFactory,
    RuleFactory,
    orgTraceApiConfig,
    VulnerabilityTrendReportFactory,
    TagFactory,
    VULNERABILITY_REPORT_RANGES,
    VULNERABILITY_REPORT_TYPE,
    APPLICATION_IMPORTANCE_LIST,
    RULE_SEVERITY_LIST,
    SERVER_ENVIRONMENT_LIST,
    FILTER_GROUPS,
    APPLICATION_LICENSES,
    TAG_TYPE
  ) {
    'ngInject'

    var _allOptionValue = 'All',
      applications = [],
      servers = [],
      rules = [],
      tags = {
        apps: [],
        servers: [],
        vulns: []
      },
      appVersions = [],
      allApplications,
      allServers,
      allRules,
      lastSearch = undefined,
      savedViews = [],
      complianceReports = []

    angular.extend($scope, {
      lastSearch: lastSearch,
      changed_assets: false,
      model: {
        type: VULNERABILITY_REPORT_TYPE.NEW,
        range: 'week',
        applications: [],
        servers: [],
        rules: []
      },
      select: {
        ranges: VULNERABILITY_REPORT_RANGES,
        applications: [],
        servers: [],
        rules: []
      },
      info: {
        loaded: false,
        closed: [],
        open: []
      },
      popover: {
        save: false
      },
      trial_license: APPLICATION_LICENSES.UNLICENSED,
      view: {
        saved_views: [],
        selected_view: null,
        is_edited: false,
        filter_search: '',
        save_dropdown: false,
        select_open: false
      }
    })

    angular.extend($scope, {
      close: close,
      onChange: onChange,
      onApplicationsUpdated: onApplicationsUpdated,
      onApplicationsDeleted: onApplicationsDeleted,
      onServersUpdated: onServersUpdated,
      onServersDeleted: onServersDeleted,
      onRulesUpdated: onRulesUpdated,
      onRulesDeleted: onRulesDeleted,
      resetFilter: resetFilter,
      selectFilter: selectFilter,
      openFilterPopover: openFilterPopover,
      closeFilterPopover: closeFilterPopover,
      openSaveDropdown: openSaveDropdown,
      saveExisting: saveExisting,
      clearFilterSearch: clearFilterSearch,
      onFilterSave: onFilterSave,
      onFilterRemove: onFilterRemove,
      openManageDialog: openManageDialog,
      hasAppVersions: hasAppVersions,
      closeChangedAssets: closeChangedAssets
    })

    function init() {
      var promises = []
      promises.push(_getApplications())
      promises.push(_getServers())
      promises.push(_getRules())
      promises.push(_getAppTags())
      promises.push(_getServerTags())
      promises.push(_getVulnTags())
      promises.push(_getSavedViews())
      promises.push(_getComplianceReports())

      var apps = reportFilterService.getApplications()
      if (apps && apps.length === 1 && reportFilterService.getIsFromAppPage()) {
        promises.push(_getAppVersions(apps[0].value))
        reportFilterService.setIsFromAppPage(false)
      } else {
        _resetModel()
      }

      $q.all(promises)
        .then(function () {
          _populateApplicationsCombobox()
          _populateServersCombobox()
          _populateVulnerabilityRulesCombobox()
          _populateSavedFilterDropdown(false)

          _setAllValues()

          _getGraphData()
        })
        .catch(ErrorService.processError)
    }

    function _setFilterValues(storedElements, array, selectArray, all) {
      if (storedElements.length > 0) {
        var element,
          i = 0

        for (; i < storedElements.length; i++) {
          element = storedElements[i]
          if (element.value === _allOptionValue) {
            array.push(all)
          } else {
            var elementFound = _.find(selectArray, function (e) {
              return e.group === element.group && e.value === element.value
            })

            if (elementFound) {
              array.push(elementFound)
            }
          }
        }
      } else {
        array.push(all)
      }
    }

    function _setAllValues() {
      var storedValues = reportFilterService.getAll()

      $scope.model.type = storedValues.type
      $scope.model.range = storedValues.range

      _setFilterValues(
        storedValues.applications,
        $scope.model.applications,
        $scope.select.applications,
        allApplications
      )
      _setFilterValues(
        storedValues.rules,
        $scope.model.rules,
        $scope.select.rules,
        allRules
      )
      _setFilterValues(
        storedValues.servers,
        $scope.model.servers,
        $scope.select.servers,
        allServers
      )
    }

    function closeChangedAssets() {
      $scope.changed_assets = false
    }

    function close() {
      _resetModel()

      var history = HistoryService.getHistory(),
        i = history.length - 1

      for (; i >= 0; i--) {
        if (history[i].indexOf('reports/view') === -1) {
          $location.path(history[i])
          return
        }
      }

      $location.path('/' + $route.current.params.orgUuid + '/reports')
    }

    function onChange() {
      reportFilterService.setType($scope.model.type)
      reportFilterService.setRange($scope.model.range)
      var appsHelper = _getValues($scope.model.applications)
      var rulesHelper = _getValues($scope.model.rules)
      var serversHelper = _getValues($scope.model.servers)

      reportFilterService.setApplications(appsHelper)
      reportFilterService.setServers(serversHelper)
      reportFilterService.setRules(rulesHelper)

      if ($scope.view.selected_view !== null) {
        var diffRange =
          $scope.view.selected_view.interval !== $scope.model.range
        $scope.view.is_edited =
          diffRange ||
          !angular.equals(
            $scope.view.selected_view.filter,
            reportFilterService.createRequest()
          )
      }

      _getGraphData()
    }

    function resetFilter() {
      _resetModel()

      _setAllValues()

      $scope.view.selected_view = null
      $scope.changed_assets = false

      _getGraphData()
    }

    function selectFilter(selectedView, setValues) {
      $scope.changed_assets = false

      if (selectedView === null) {
        $scope.view.selected_view = null
      } else {
        $scope.view.selected_view = selectedView

        _resetModel()

        $scope.changed_assets = reportFilterService.unwrapRequest(
          selectedView,
          $scope.select,
          allApplications,
          allServers,
          allRules
        )

        $scope.model.range = selectedView.interval
        reportFilterService.setRange(selectedView.interval)

        if ($scope.changed_assets) {
          var data = {
            view_name: $scope.view.selected_view.name,
            filter_view: JSON.stringify(reportFilterService.createRequest()),
            interval: $scope.model.range
          }

          VulnerabilityTrendReportFactory.editFilter(
            $scope.view.selected_view.value,
            data
          )
        }

        if (setValues) {
          _setAllValues()
        }

        $scope.view.filter_search = ''
      }

      _getGraphData()
    }

    function _getValues(elements) {
      var helper = [],
        i = 0,
        element
      for (; i < elements.length; i++) {
        element = elements[i]
        if (
          element.value !== _allOptionValue &&
          angular.isDefined(element.group)
        ) {
          helper.push({ value: element.value, group: element.group })
        }
      }
      return helper
    }

    function onApplicationsUpdated() {
      _updateMultiSelect($scope.model.applications)
      _handleAppFilterChange().then(onChange)
    }

    function onApplicationsDeleted() {
      _deleteMultiSelect($scope.model.applications, allApplications)
      _handleAppFilterChange().then(onChange)
    }

    function onServersUpdated() {
      _updateMultiSelect($scope.model.servers)
      onChange()
    }

    function onServersDeleted() {
      _deleteMultiSelect($scope.model.servers, allServers)
      onChange()
    }

    function onRulesUpdated() {
      _updateMultiSelect($scope.model.rules)
      onChange()
    }

    function onRulesDeleted() {
      _deleteMultiSelect($scope.model.rules, allRules)
      onChange()
    }

    function _getApplications() {
      var transl = {
        title_allApplications: $translate.instant('title_allApplications')
      }

      $scope.applicationsPromise = ApplicationFactory.getApplicationBase(
        false
      ).then(function (response) {
        applications = response.data.applications
        allApplications = {
          name: transl.title_allApplications + ' (' + applications.length + ')',
          value: _allOptionValue
        }
      }, ErrorService.processError)

      return $scope.applicationsPromise
    }

    function _populateApplicationsCombobox() {
      var importance = angular.copy(APPLICATION_IMPORTANCE_LIST),
        i = 0
      _.each(importance, function (element) {
        _.extend(element, { group: FILTER_GROUPS.IMPORTANCE })
      })

      $scope.select.applications = importance
        .concat(tags.apps)
        .concat(appVersions)

      for (; i < applications.length; i++) {
        var app = applications[i]
        if (app.child === false) {
          var licenseGroup = ''

          if (app.license_level === APPLICATION_LICENSES.LICENSED) {
            licenseGroup = FILTER_GROUPS.LICENSED
          } else if (app.license_level === APPLICATION_LICENSES.UNLICENSED) {
            licenseGroup = FILTER_GROUPS.UNLICENSED
          }

          $scope.select.applications.push({
            name: app.name,
            value: app.app_id,
            group: licenseGroup,
            primary: app.primary
          })
        }
      }
    }

    function _getServers() {
      var transl = {
        title_allServers: $translate.instant('title_allServers')
      }

      $scope.serversPromise = ServerFactory.getServersBase().then(function (
        response
      ) {
        servers = response.data.servers
        allServers = {
          name: transl.title_allServers + ' (' + servers.length + ')',
          value: _allOptionValue
        }
      },
      ErrorService.processError)

      return $scope.serversPromise
    }

    function _populateServersCombobox() {
      var environment = angular.copy(SERVER_ENVIRONMENT_LIST),
        i = 0
      _.each(environment, function (element) {
        _.extend(element, { group: FILTER_GROUPS.ENVIRONMENT })
      })

      $scope.select.servers = environment.concat(tags.servers)

      for (; i < servers.length; i++) {
        var server = servers[i]
        $scope.select.servers.push({
          name: server.name,
          value: server.server_id,
          group: FILTER_GROUPS.SERVERS
        })
      }
    }

    function _getRules() {
      var transl = {
        title_allRules: $translate.instant('title_allRules')
      }

      $scope.rulesPromise = RuleFactory.getRulesBase().then(function (
        response
      ) {
        rules = response.data.rules
        allRules = {
          name: transl.title_allRules + ' (' + rules.length + ')',
          value: _allOptionValue
        }
      },
      ErrorService.processError)

      return $scope.rulesPromise
    }

    function _populateVulnerabilityRulesCombobox() {
      var severities = angular.copy(RULE_SEVERITY_LIST),
        rule,
        i = 0
      _.each(severities, function (element) {
        _.extend(element, { group: FILTER_GROUPS.SEVERITY })
      })

      var reports = angular.copy(complianceReports)
      _.each(reports, function (complianceReport) {
        _.extend(complianceReport, { group: FILTER_GROUPS.SECURITY_STANDARDS })
      })

      $scope.select.rules = severities.concat(tags.vulns)
      $scope.select.rules = $scope.select.rules.concat(_.values(reports))

      for (; i < rules.length; i++) {
        rule = rules[i]
        $scope.select.rules.push({
          name: rule.title,
          value: rule.name,
          group: FILTER_GROUPS.VULNERABILITY_RULES
        })
      }
    }

    function _getGraphData() {
      $scope.info.loaded = false

      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      var form = reportFilterService.createRequest()

      if ($scope.model.type === VULNERABILITY_REPORT_TYPE.NEW) {
        lastSearch = orgTraceApiConfig.getNewTrendData($scope.model.range, form)
      } else {
        lastSearch = orgTraceApiConfig.getTotalTrendData(
          $scope.model.range,
          form
        )
      }

      return lastSearch.then(function (response) {
        $scope.info.closed = response.data.closed
        $scope.info.open = response.data.open
        $scope.info.loaded = true
      }, ErrorService.processError)
    }

    function _getAppTags() {
      return TagFactory.getApplicationsTags().then(function (response) {
        tags.apps = _extendTags(response.data.tags, FILTER_GROUPS.APP_TAGS)
      })
    }

    function _getServerTags() {
      return TagFactory.getServersTags().then(function (response) {
        tags.servers = _extendTags(
          response.data.tags,
          FILTER_GROUPS.SERVER_TAGS
        )
      })
    }

    function _getVulnTags() {
      return TagFactory.getTraceTagsByOrganization().then(function (response) {
        tags.vulns = _extendTags(response.data.tags, FILTER_GROUPS.VULN_TAGS)
      })
    }

    function _getSavedViews() {
      return VulnerabilityTrendReportFactory.getSavedFilters().then(function (
        response
      ) {
        savedViews = response.data.views
      })
    }

    function _getComplianceReports() {
      return complianceReportService.getReports().then(function (reports) {
        _.each(reports, function (report) {
          complianceReports.push({
            value: report.type,
            name: report.short_name
          })
        })
      })
    }

    function _populateSavedFilterDropdown(filterName) {
      var i = 0

      for (; i < savedViews.length; i++) {
        var filter = savedViews[i]

        $scope.view.saved_views.push({
          name: filter.viewName,
          value: filter.id,
          filter: filter.filterRequest,
          view: filter.filterView,
          interval: filter.interval
        })
      }

      if (filterName !== null && filterName.length > 0) {
        $scope.view.selected_view = _getSavedViewByName(filterName)
      }
    }

    function _getAppVersions(appId) {
      return TagFactory.getTraceTagsByApplication(
        appId,
        TAG_TYPE.APPLICATION_VERSION
      ).then(function (response) {
        appVersions = _extendTags(
          response.data.tags,
          FILTER_GROUPS.BUILD_NUMBERS
        )
      })
    }

    function _extendTags(tags, group) {
      return tags.map(function (tag) {
        return {
          value: tag,
          name: tag,
          group: group
        }
      })
    }

    function openFilterPopover() {
      $scope.popover.save = true
    }

    function closeFilterPopover() {
      $scope.popover.save = false
    }

    function saveExisting() {
      var transl = {
        detail_vulnerabilityTrend_saveReportSuccess: $translate.instant(
          'detail_vulnerabilityTrend_saveReportSuccess'
        ),
        detail_vulnerabilityTrend_saveReportError: $translate.instant(
          'detail_vulnerabilityTrend_saveReportError'
        )
      }

      var data = {
        view_name: $scope.view.selected_view.name,
        filter_view: JSON.stringify(reportFilterService.createRequest()),
        interval: $scope.model.range
      }

      VulnerabilityTrendReportFactory.editFilter(
        $scope.view.selected_view.value,
        data
      ).then(
        function () {
          logger.logSuccess(transl.detail_vulnerabilityTrend_saveReportSuccess)

          $scope.view.is_edited = false

          $scope.view.selected_view.filter = reportFilterService.createRequest()
        },
        function () {
          logger.logError(transl.detail_vulnerabilityTrend_saveReportError)
        }
      )
    }

    function onFilterSave(filterName) {
      _refreshSavedFilters(filterName)

      $scope.view.is_edited = false
    }

    function onFilterRemove() {
      _refreshSavedFilters(null)

      resetFilter()
    }

    function openSaveDropdown() {
      if (
        $scope.view.selected_view === null ||
        ($scope.view.selected_view !== null && !$scope.view.is_edited)
      ) {
        $scope.view.save_dropdown = false
        openFilterPopover()
      } else {
        $scope.view.save_dropdown = true
      }
    }

    function clearFilterSearch() {
      $scope.view.filter_search = ''
    }

    function openManageDialog() {
      dialogs
        .create(
          'components-org/reports/modal_manage_filters.html',
          'VulnerabilityTrendReportFilterManageCtrl',
          $scope.view,
          {
            backdrop: 'static',
            size: 'md-sm'
          }
        )
        .result.then(function (promises) {
          $q.all(promises)
            .then(function () {
              _refreshSavedFilters(null)

              resetFilter()
            })
            .catch(ErrorService.processError)
        })
    }

    function hasAppVersions() {
      return angular.isDefined(
        _.find($scope.select.applications, {
          group: FILTER_GROUPS.BUILD_NUMBERS
        })
      )
    }

    function _updateMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.value === _allOptionValue
      })

      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    function _deleteMultiSelect(array, allOption) {
      if (array.length === 0) {
        array.push(allOption)
        return true
      } else {
        return false
      }
    }

    function _handleAppFilterChange() {
      if (_countAppsSelected($scope.model.applications) === 1) {
        var appVersionFilter = $scope.model.applications.find(function (item) {
          return (
            item.group === FILTER_GROUPS.LICENSED ||
            item.group === FILTER_GROUPS.UNLICENSED
          )
        })
        return _addAppVersionsIfDoesntExist(
          $scope.select.applications,
          appVersionFilter.value
        )
      } else {
        $scope.select.applications = _removeAppVersions(
          $scope.select.applications
        )
        return $q.when()
      }
    }

    function _countAppsSelected(array) {
      return array.reduce(function (count, item) {
        return (
          count +
          (item.group === FILTER_GROUPS.LICENSED ||
          item.group === FILTER_GROUPS.UNLICENSED
            ? 1
            : 0)
        )
      }, 0)
    }

    function _removeAppVersions(filters) {
      return _.filter(filters, function (item) {
        return item.group !== FILTER_GROUPS.BUILD_NUMBERS
      })
    }

    function _addAppVersionsIfDoesntExist(filters, appId) {
      var appVersionFilter = filters.find(function (item) {
        return item.group === FILTER_GROUPS.BUILD_NUMBERS
      })
      if (!appVersionFilter) {
        return _getAppVersions(appId).then(function () {
          $scope.select.applications =
            $scope.select.applications.concat(appVersions)
        })
      }
      return $q.when()
    }

    function _resetModel() {
      $scope.model.applications = []
      $scope.model.servers = []
      $scope.model.rules = []

      reportFilterService.clear()
    }

    function _refreshSavedFilters(filterName) {
      $scope.view.saved_views = []
      $scope.view.selected_view = null

      _getSavedViews().then(function () {
        _populateSavedFilterDropdown(filterName)
      })
    }

    function _getSavedViewByName(name) {
      return _.find($scope.view.saved_views, function (v) {
        return v.name === name
      })
    }

    init()
  }
})()
